const ProjectCard = ({ data }) =>
{
  return (
    <>

      <div data-aos="fade-down" data-aos-delay="300" className=" px-4 py-4 border mx-auto w-[90%] sm:w-[48%] md:w-[43%] lg:w-[30%] border-[#ABB2BF]">
        <h2 className="text-[#FFFFFF] text-2xl font-medium text-centern text-center" >{data.name}</h2>
        <div className=" my-4 border-t border-[#ABB2BF]"></div>
        <div className="text-gray-400 min-h-32  overflow-hidden ">{data.linerDescription}</div>
        <div className="my-2 mb-4 border-t border-[#ABB2BF]"></div>
        <div className="text-gray-400 flex justify-around">
          <Technology key={0} element={data.technologies.frontend.name} />
          |
          <Technology key={1} element={data.technologies.backend.name} />
          |
          <Technology key={2} element={data.technologies.database.name} />
        </div>
        <div className="my-2 mb-4 border-t border-[#ABB2BF]"></div>
        <div className="flex justify-center transition-all duration-300">
          <button className=" border-2 mx-auto border-[#C778DD] hover:bg-[#C778DD33] text-white hover:w-[90%] hover:md:w-[75%] hover:lg:w-[50%] rounded-full px-2 py-2 flex justify-center ">
            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-brand-github" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5"></path>
            </svg>
          </button>
        </div>
      </div>
    </>
  );
};

export default ProjectCard;


const Technology = ({ element }) =>
{
  return (
    <h1 className=" text-center text-[#C778DD] px-2 py-[4px]">
      {element}
    </h1>
  );
}



/*
data-aos="fade-up"
data-aos-delay="300"
<div className="">
<img className=" w-full p-2 rounded-2xl" src={img} alt="" />
</div>
<div className=" py-4 px-2 border-t border-[#ABB2BF]">
<h2 className="text-[#FFFFFF] text-2xl font-medium text-centern " >{title}</h2>
</div>

*/
